import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import StepRoutes from "../../../Routes/steps_routes";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { useEffect } from "react";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { extractDate } from "../../../Components/Functions/date.fun";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";

const ViewRefund = () => {
  const [data, setData] = useState();
  let { id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(false);
  const [leadOwner, setLeadOwner] = useState();
  const [updateData, setupdateData] = useState({
    reqStatus: "",
    statusFeedback: "",
    paymentImage: "",
  });

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/request/getreqRefundByID/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Expense!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id, refresh]);

  const RefundValues = (event) => {
    const { name, value, files } = event.target;
    if (name == "reqStatus") {
      setupdateData((prv) => {
        return { ...prv, reqStatus: value };
      });
    } else if (name == "statusFeedback") {
      setupdateData((prv) => {
        return { ...prv, statusFeedback: value };
      });
    } else if (name == "paymentImage") {
      setupdateData((prv) => {
        return { ...prv, paymentImage: files[0] };
      });
    }
  };

  // const handelSubmit = (e) => {
  //   const formData = new FormData();
  //   formData.append("reqStatus", updateData.reqStatus);
  //   formData.append("statusFeedback", updateData.statusFeedback);
  //   if (updateData.paymentImage) {
  //     formData.append("paymentImage", updateData.paymentImage); // attach file only if selected
  //   }
  //   const headers = { "content-type": "multipart/form-data" };

  //   performRequest("PATCH", `/request/updatereqRefund/${id}`, formData, headers)
  //     .then((res) => {
  //       if (res.status === 200) {
  //         document.getElementById("modal-close").click();
  //         setRefresh(!refresh);
  //         Toast("success", "Request Status updated successfully!");
  //       } else {
  //         document.getElementById("modal-close").click();
  //         Toast("error", "Error while uploading");
  //       }
  //     })
  //     .catch((err) => {
  //       CustomErrorResponse(err);
  //     });
  //   e.preventDefault();
  // };
  const handelSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("reqStatus", updateData.reqStatus);
    formData.append("statusFeedback", updateData.statusFeedback);
    if (updateData.paymentImage) {
      formData.append("paymentImage", updateData.paymentImage);
    }

    performRequest("PATCH", `/request/updatereqRefund/${id}`, formData)
      .then((res) => {
        if (res.status === 200) {
          document.getElementById("modal-close").click();
          setRefresh(!refresh);
          Toast("success", "Request Status updated successfully!");
        } else {
          document.getElementById("modal-close").click();
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };
  useEffect(() => {
    if (data) {
      let { contactNumber } = data;
      contactNumber = contactNumber?.trim();
      if (contactNumber?.length < 2) {
        return;
      }

      performRequest(
        "GET",
        `/leads_v2/getLeadForSell/?search=${encodeURIComponent(contactNumber)}`
      )
        .then((res) => {
          if (res.status === 200) {
            if (res?.data?.leads?.[0]?.reAssignTo) {
              setLeadOwner(res.data?.leads?.[0]?.reAssignTo);
            }
            // setIsDropdown(res.data?.leads || []);
          } else {
            Toast("error", "Error while fetching leads!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    }
  }, [data]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">Refund</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header row g-2 align-items-center">
              <div className="col">
                <h2>View Refund</h2>
              </div>
              <div className="col-auto ms-auto d-print-none"></div>
            </div>
            <div className="card-body">
              {data && (
                <>
                  <div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Request For
                      </label>
                      <div className="w-100 col">
                        {(data?.reqFor || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Request Date
                      </label>
                      <div className="w-100 col">
                        {(extractDate(data?.createdAt) || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Email</label>
                      <div className="w-100 col">
                        {(data?.email || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Contact number
                      </label>
                      <div className="w-100 col">
                        {(data?.contactNumber || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Payment Receipt
                      </label>
                      <div className="w-100 col">
                        <img
                          src={`${data?.paymentReceipt}`}
                          style={{ height: "300px", width: "50%" }}
                          alt="Payment Receipt"
                        ></img>
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Lead Owner
                      </label>
                      <div className="w-100 col">
                        {(leadOwner || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Message</label>
                      <div className="w-100 col">
                        {(data?.message || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Request Status
                      </label>
                      <div className="w-100 col">
                        {(data?.reqStatus || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Status Feedback
                      </label>
                      <div className="w-100 col">
                        {data?.statusFeedback || "N/A"}
                      </div>
                    </div>
                  </div>
                  <div>
                    <hr></hr>
                    <h2>Bank Details</h2>
                    <hr></hr>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Account Holder Name
                      </label>
                      <div className="w-100 col">
                        {(data?.accountholderName || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Bank Name</label>
                      <div className="w-100 col">
                        {(data?.bankName || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Account Number
                      </label>
                      <div className="w-100 col">
                        {(data?.accountNumber || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">IFSC Code</label>
                      <div className="w-100 col">
                        {(data?.ifcCode || "N/A").toUpperCase()}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Paid Receipt
                      </label>
                      <div className="w-100 col">
                        {/* {(data?.paymentImage || "N/A")} */}
                        {/* <img
                          src={data?.paymentImage}
                          alt="Paid Receipt"
                          style={{ height: "300px", width: "50%" }}
                        ></img> */}

                        <LazyImageComponent
                          // width={"200px"}
                          // style={{ paddingBottom: "30px", paddingTop: "auto" }}
                          src={data?.paymentImage}
                          alt={"Paid Receipt"}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <button
                  className="btn mx-1 mt-2 btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#modal-refund"
                >
                  Edit
                </button>
                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal modal-blur fade"
          id="modal-refund"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Refund Status</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <form onSubmit={handelSubmit}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Feedback</label>
                    <textarea
                      onChange={(event) => RefundValues(event)}
                      required
                      rows={5}
                      className="form-control"
                      name="statusFeedback"
                    ></textarea>
                  </div>
                  <div class="col-md-12">
                    <div class="mb-3">
                      <label class="form-label">Status</label>
                      <select
                        className="form-control form-select"
                        name="reqStatus"
                        onChange={(event) => RefundValues(event)}
                      >
                        <option value="">Select</option>
                        <option value="Pending">Pending</option>
                        <option value="Inprocess">Inprocess</option>
                        <option value="Completed">Completed</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Paid Receipt</label>
                      <div className="">
                        <input
                          name="paymentImage"
                          type="file"
                          onChange={(event) => RefundValues(event)}
                          className="form-control"
                        />
                        {/* {props.touched.image && props.errors.image && (
                          <p className="text-danger">{props.errors.image}</p>
                        )} */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    id="modal-close"
                    type="button"
                    className="btn me-auto"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewRefund;
